import Header from "./components/Header";
import Hero from "./components/Hero";
import Timeline from "./components/Timeline";
import Zones from "./components/Zones";
import Truth from "./components/Truth";
import Mystery from "./components/Mystery";
import Insider from "./components/Insider";
import Talk from "./components/Talk";
import CtaFooter from "./components/CtaFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <Timeline />
        <Zones />
        <Truth />
        <Mystery />
        <Insider />
        <Talk />
        <CtaFooter />
      </main>
    </div>
  );
}